import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface CercaEletronica {
    id: number;
    nome: string;
    endereco: string;
    latitude: number;
    longitude: number;
    raio: number;
    empresaId?: number;
}

export interface CercaMaisProxima {
  id: number;
  nome: string;
  endereco: string;
  distanciaMetros: number;
  raio: number;
  latitude: number;
  longitude: number;
}

export interface VerificacaoLocalizacao {
  dentro: boolean;
  mensagem: string;
  cercaMaisProxima: CercaMaisProxima | null;
  distanciaMetros: number;
}

@Injectable({
    providedIn: 'root'
})
export class CercaEletronicaService {

    constructor(private http: HttpClient) { }

    listarPorEmpresa(empresaId: number): Observable<CercaEletronica[]> {
        return this.http.get<CercaEletronica[]>(`/cercas/empresa/${empresaId}`);
    }

    buscarPorTermo(empresaId: number, termo: string): Observable<CercaEletronica[]> {
        let params = new HttpParams();
        if (termo && termo.trim().length > 0) {
            params = params.set('termo', termo.trim());
        }
        return this.http.get<CercaEletronica[]>(`/cercas/empresa/${empresaId}/buscar`, { params });
    }

    buscarPorId(id: number): Observable<CercaEletronica> {
        return this.http.get<CercaEletronica>(`/cercas/${id}`);
    }

    criar(cerca: CercaEletronica): Observable<CercaEletronica> {
        return this.http.post<CercaEletronica>(`/cercas`, cerca);
    }

    atualizar(id: number, cerca: CercaEletronica): Observable<CercaEletronica> {
        return this.http.put<CercaEletronica>(`/cercas/${id}`, cerca);
    }

    deletar(id: number): Observable<void> {
        return this.http.delete<void>(`/cercas/${id}`);
    }

    salvar(cerca: CercaEletronica): Observable<CercaEletronica> {
        if (cerca.id && cerca.id > 0) {
            return this.atualizar(cerca.id, cerca);
        }
        return this.criar(cerca);
    }

    buscarProximas(empresaId: number, latitude: number, longitude: number): Observable<CercaEletronica[]> {
        let params = new HttpParams()
            .set('empresaId', empresaId.toString())
            .set('latitude', latitude.toString())
            .set('longitude', longitude.toString());

        return this.http.get<CercaEletronica[]>(`/cercas/proximas`, { params });
    }

    verificarLocalizacaoParaPonto(empresaId: number, latitude: number, longitude: number): Observable<VerificacaoLocalizacao> {
        let params = new HttpParams()
            .set('empresaId', empresaId.toString())
            .set('latitude', latitude.toString())
            .set('longitude', longitude.toString());

        return this.http.get<VerificacaoLocalizacao>(`/cercas/verificar-ponto`, { params });
    }
}